import { apiClient } from '@/utils/api';
import { Appointment } from './appointmentService';

export interface AgendaSummary {
  total: number;
  scheduled: number;
  confirmed: number;
  inProgress: number;
  completed: number;
  cancelled: number;
  noShow: number;
  pending?: number;
}

export interface AgendaData {
  date: string;
  appointments: Appointment[];
  summary: AgendaSummary;
}

export interface AgendaWeekData {
  year: number;
  week: number;
  weekStart: string;
  weekEnd: string;
  appointmentsByDay: Record<string, Appointment[]>;
  dailySummary: Record<string, { total: number; confirmed: number; scheduled: number; completed: number }>;
  totalAppointments: number;
}

export interface ConvertToPracticeData {
  typeId: string;
  title?: string;
  description?: string;
  priority?: 'LOW' | 'MEDIUM' | 'HIGH' | 'URGENT';
}

export const agendaService = {
  // GET /api/agenda/today
  async getAgendaToday(userId?: string) {
    const response = await apiClient.get('agenda/today', {
      params: userId ? { userId } : {},
    });
    return response.data;
  },

  // GET /api/agenda/date/:date
  async getAgendaByDate(date: string, userId?: string) {
    const response = await apiClient.get(`agenda/date/${date}`, {
      params: userId ? { userId } : {},
    });
    return response.data;
  },

  // GET /api/agenda/week/:year/:week
  async getAgendaByWeek(year: number, week: number, userId?: string) {
    const response = await apiClient.get(`agenda/week/${year}/${week}`, {
      params: userId ? { userId } : {},
    });
    return response.data;
  },

  // GET /api/agenda/summary
  async getAgendaSummary(date?: string, userId?: string) {
    const response = await apiClient.get('agenda/summary', {
      params: { date, userId },
    });
    return response.data;
  },

  // GET /api/agenda/range
  async getAgendaByRange(startDate: string, endDate: string, userId?: string) {
    const response = await apiClient.get('agenda/range', {
      params: { startDate, endDate, userId },
    });
    return response.data;
  },

  // POST /api/appointments/:id/convert-to-practice
  async convertToPractice(appointmentId: string, data: ConvertToPracticeData) {
    const response = await apiClient.post(`appointments/${appointmentId}/convert-to-practice`, data);
    return response.data;
  },
};
